import * as React from 'react';

import {useApi} from 'src/hooks/useApi';
import {DismissableNotification} from './notification';


export default function AppStatusNotification() {
  // NOTE (kyle): we don't care about loading or errors
  const {result} = useApi('app-status/announcement');

  if (!result) {
    return null;
  }

  return (
    <DismissableNotification flag="app-status-announcement">
      {/* @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'ReactNode'. */}
      {result}
    </DismissableNotification>
  );
}
